/**
 * Discount Notification System
 * Detects discount codes in URL and displays notifications
 */

// Debug logging function
function log(message, data = null) {
  if (window.debugDiscountNotification) {
    console.log(`🏷️ [Discount]: ${message}`, data || '');
  }
}


// Cookie management functions
// Set Cookie value with expiration date
function setCookie(cookieName, cookieValue, expires = 14) {
  const today = new Date();
  let expire;

  if (expires === 0) {
    expire = 0;
  } else {
    expire = new Date();
    expire.setTime(today.getTime() + 3600000 * 24 * expires);
    expire = expire.toGMTString();
  }
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";path=/;expires=" + expire;
}

// Get Cookie value
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift();
    log(`Cookie retrieved: ${name}=${cookieValue}`);
    return cookieValue;
  }
  log(`Cookie not found: ${name}`);
  return null;
}

// Notification display function
function showDiscountNotification(code) {
  const notificationBar = document.querySelector('.discount-notificaiton-bar');
  const notificationText = document.querySelector('.discount-notificaiton-bar__text');
  if (!notificationBar || !notificationText) {
    log('Notification elements not found');
    return;
  }

  activateDiscountNotification();


  log('Showing notification for code', code);

  // Get message template from theme settings
  const discountMsg = notificationBar.getAttribute('data-discount-text');
  const formattedMsg = discountMsg.replace('[code]', `<span class="body-s bold">${code}</span>`);

  // Show notification
  notificationText.innerHTML = formattedMsg;
  notificationBar.setAttribute('open', 'true');

  // Add close button event listener
  const closeButton = notificationBar.querySelector('.close-icon');
  if (closeButton) {
    log('Adding close butt n event listener');
    closeButton.addEventListener('click', function () {
      log('Close button clicked');
      notificationBar.setAttribute('open', 'false');
    });
  }

  // Auto-hide after timeout (configurable)
  const timeout = parseInt(notificationBar.getAttribute('data-timeout') || '3000');
  log(`Setting auto - hide timeout: ${timeout}ms`);
  setTimeout(function () {
    log('Auto-hiding notification');
    notificationBar.setAttribute('open', 'false');
  }, timeout);
}

// URL discount code detection
function detectDiscountCodeFromURL() {
  const url = window.location.href;
  log('Checking URL for discount code', url);

  const discountPattern = /\/discount\/([^\/\?&#]+)/;
  const match = url.match(discountPattern);

  if (match && match[1]) {
    const code = decodeURIComponent(match[1]).toUpperCase();
    log('Found discount code in URL', code);

    // Check if we've already shown this code in this session
    const lastShownCode = sessionStorage.getItem("lastDiscountCode");
    log('Last shown code from session storage', lastShownCode);

    if (lastShownCode !== code) {
      log('New discount code detected, showing notification');

      // Save the code to cookie
      setCookie("discount_code", code);

      // Show notification
      showDiscountNotification(code);

      // Save to session storage to prevent showing again
      sessionStorage.setItem("lastDiscountCode", code);
      log('Saved code to session storage');

      // Remove the discount code from URL without reloading the page
      const newUrl = url.replace(discountPattern, '');
      log('Updating URL without discount code', newUrl);
      window.history.replaceState({}, document.title, newUrl);
    } else {
      log('Discount code already shown in this session, skipping notification');
    }
  } else {
    log('No discount code found in URL');

    // Check if there's a discount code in the cookie but not shown yet in this session
    checkExistingDiscountCode();
  }
}

// Check for existing discount code i  cookies
function checkExistingDiscountCode() {
  const existingCode = getCookie("discount_code");
  const lastShownCode = sessionStorage.getItem("lastDiscountCode");

  if (existingCode && !lastShownCode) {
    log('Found existing discount code in cookie but not shown in this session', existingCode);

    // Show notification for existing code
    showDiscountNotification(existingCode);

    // Save to session storage
    sessionStorage.setItem("lastDiscountCode", existingCode);
  }
}

function activateDiscountNotification() {
  const discountNotification = document.querySelector('.discount-notificaiton-bar');
  const parentHeaderGroup = discountNotification ? discountNotification.parentElement : null;
  if (parentHeaderGroup) {
    parentHeaderGroup.style.display = 'block';
  }
}

// Enable debug logging (set to true to see logs)
window.debugDiscountNotification = false;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  log('DOM loaded, initializing discount code detection');
  detectDiscountCodeFromURL();

  // Fix for notification bar close button
  const closeButtons = document.querySelectorAll('.discount-notificaiton-bar .close-icon');
  closeButtons.forEach(button => {
    log('Adding event listener to close button');
    button.addEventListener('click', function () {
      const bar = this.closest('.discount-notificaiton-bar');
      if (bar) {
        log('Close button clicked');
        bar.setAttribute('open', 'false');
      }
    });
  });
});
